
import cleanSku from '@util/cleanSku';
import {toProductUrl} from '@util/URLUtils';
import SizedImage from '../../common/SizedImage';
import Icon from '../../common/Icon';
import Item from './Item';

const cls = {
    root: 'flex py-2 px-4 border-b border-solid border-grey-lighter',
    left: 'flex-0 w-24',
    right: 'flex-1 w-px pl-2',
    thumbnail: 'block border border-solid border-grey-lighter bg-white',
    title: 'ellipsis leading-normal my-0 text-sm',
    detail: 'my-0 text-sm',
    after: 'pl-2 self-center'
};

const ItemProduct = (
    {sku, longName, shortName, indicator, url, className = '', ...props},
    {conf}
) => {
    const attrs = {};
    const skuDisplay = cleanSku( sku );
    const isEcommerceSite = conf.isEcommerceSite;

    if ( isEcommerceSite ) {
        attrs['data-quick-view'] = true;
        attrs['data-sku'] = sku;
    }

    if ( url ) {
        attrs.href = toProductUrl( {
            path: url,
            sku: skuDisplay
        } )
    }

    return (
        <Item className={[cls.root, className].join( ' ' )}
              {...attrs}
              {...props}>
            <div className={cls.left}>
                <div className="img-ratio-4x3">
                    <SizedImage type="sku" src={sku} alt={longName} className={cls.thumbnail}/>
                </div>
            </div>
            <div className={cls.right}>
                <h4 className={cls.title}>{longName}</h4>
                <p className={cls.detail}>{indicator} #{skuDisplay}</p>
            </div>
            {isEcommerceSite ?
                <div className={cls.after}>
                    <Icon.ui name="shopping-cart-add" className="text-xl"/>
                </div>
                : null
            }
        </Item>
    );
};

export default ItemProduct;
